<template>
  <div class="order-wrapper">
    <div class="header-text">
      <span class="fill-order">填写订单信息</span>
      <span class="order-success on">订单提交成功</span>
    </div>
    <div class="bottom-bg">
      <div class="top-bg top-bg-all"></div>
    </div>
    <div class="order_success order_success_o order-result">
      <div v-if="is_success">
        <img alt class="order-result-icon" src="@/assets/images/html/success_03.png">
        <div class="order-result-msg">
          <div class="one">
            <span>订单提交成功，请尽快收款！</span>
          </div>
        </div>
      </div>
      <div class="order-result-error" v-else>
        <img alt class="order-result-icon" src="@/assets/images/html/fail.png">
        <div class="order-result-msg">
          <div class="one">
            <span>订单提交失败！{{msg}}&nbsp;请联系旅行销售客服！</span>
          </div>
          <div class="customer_service_information order-result-userinfo call_agent" v-if="op_userinfo.cell">
            <em>操作OP：</em>
            <em>{{op_userinfo.name}}</em>
            <a :href="'tel:' + op_userinfo.cell" class="tel">
              <img alt="电话号码" class="user-tel" src="@/assets/images/html/call_03.png">
              <span>{{op_userinfo.cell}}</span>
            </a>
          </div>
        </div>
        <div class="order-result-error-button">
          <a @click="$router.go(-1)" href="javascript:void(0);">
            <span>返回</span>
          </a>
        </div>
      </div>
    </div>
    <div class="order-result-bottom" v-if="is_success">
      <div class="order-result-route-info">
        <div>
          <div class="one overflow-ellipsis-line1">
            <span>产品名称：</span>
            <em>{{plan_info.route_plan_name}}</em>
          </div>
          <div class="tow">
            <span>订单编号：</span>
            <em>{{order_info.order_info_id}}</em>
          </div>
          <a
            @click="$pushByName('agentOrderDetail',{order_id: order_info_id})"
            href="javascript:void(0);"
          >
            <em>查看订单详情</em>
            <img alt src="~@/assets/images/html/blue_arrow_07.png">
          </a>
        </div>
        <div>
          <div class="one">
            <span>出行日期：</span>
            <em>{{is_visa ? order_info.travel_date : $dateUtil.df(plan_info.depart_time)}}</em>
          </div>
          <div class="tow order-result-userinfo" style="width:370px;">
            <span>联系人：</span>
            <em>{{order_info.contact_person}}</em>
            <a :href="'tel:' + order_info.contact_tel" class="tel">
              <img alt="电话号码" class="user-tel" src="@/assets/images/html/call_03.png">
              <span>{{order_info.contact_tel}}</span>
            </a>
          </div>
        </div>
        <div>
          <div class="one">
            <span>订单金额：</span>
            <i>{{order_info.total_amount | currency}}</i>
          </div>
          <div class="tow">
            <a
              @click="is_expansion=!is_expansion"
              href="javascript:void(0);"
              style="color: black;"
            >明细&nbsp;V</a>
          </div>
        </div>
        <transition>
          <div class="order-amount-info-table" v-show="is_expansion">
            <table>
              <tr>
                <th id="price_categories">价格种类</th>
                <th>单价</th>
                <th>订购</th>
                <th>应收金额</th>
              </tr>
              <tr v-for="(price_item, index) in price_list" v-if="price_list.length > 0">
                <td class="text">{{price_item.name}}</td>
                <td>{{price_item.price}}</td>
                <td>{{price_item.num}}</td>
                <td style="color:#313131;">{{price_item.total}}</td>
              </tr>
            </table>
          </div>
        </transition>
        <div>
          <h2 class="order-info-h2" style="margin-top:40px;">固定信用额度</h2>
          <div class="one">
            <span>下单前可用：</span>
            <i>{{$number.formatStr($number.add(can_use_credit_amount, order_info.total_amount))}}</i>
          </div>
          <div class="tow">
            <span>本次使用：</span>
            <i>{{$number.formatStr(order_info.total_amount)}}</i>
          </div>
          <div>
            <span>下单后可用：</span>
            <i>{{$number.formatStr(can_use_credit_amount)}}</i>
          </div>
        </div>
      </div>
      <div class="order-result-error-button" v-if="$defines.is_allow_pay">
        <a @click="$pushByName('orderReceive',{order_id:order_info_id})" href="javascript:void(0);">
          <span>收款</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RouteOrderResult',
  componentName: 'RouteOrderResult',
  data () {
    return {
      is_expansion: false,
      is_success: false,
      msg: '',
      _user_name: '',
      order_info_id: 0,
      userinfo: {},
      plan_info: {},
      order_info: {},
      can_use_credit_amount: 0,
      price_list: [], //价格明细
      dingjin: 0,
      is_visa: false,
      op_userinfo:{}
    }
  },
  created () {
    this.init()
    this.getRouteOrderResult()
  },
  mounted () {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }
  },
  destroyed () {
    window.removeEventListener('popstate', this.goBack, false);
  },
  methods: {
    goBack () {
      window.removeEventListener('popstate', this.goBack, false)
      if (this.is_success) {
        this.$router.replace({ name: 'personalCenter' })
      } else {
        this.$router.go(-1)
      }
    },
    init () {
      this.is_success = this.$route.query.is_success
      //this.is_success = true
      this.msg = this.$route.query.msg
      this.order_info_id = this.$route.query.order_info_id
      this.can_use_credit_amount = this.$route.query.can_use_credit_amount

      const price_list = this.$sessionStorageUtil.get('price_list')
      if (price_list) {
        this.price_list = price_list
      }
    },
    getRouteOrderResult () { // 从后台接口获取订单列表，
      const url = 'order_info/get_route_order_result'
      const form_info = {
        _user_name: this.$sessionStorageUtil.get('agent_username'),
        order_info_id: this.order_info_id
      }
      if(this.is_success == false){
        form_info.is_success = this.is_success
        let planInfo = this.$sessionStorageUtil.get('route_order_plan_info')
        if(planInfo){
          form_info.op_name = planInfo.editor
        }
      }
      var fields = this.$myPost(url, form_info)
      fields.then(res => {
        this.userinfo = res.response.data.userinfo
        this.plan_info = res.response.data.plan_info
        this.order_info = res.response.data.order_info
        this.dingjin = res.response.data.dingjin
        this.op_userinfo = res.response.data.op_userinfo
        if (this.order_info.product_category == 10) {
          this.is_visa = true
          this.order_info.travel_date = JSON.parse(this.order_info.order_note).speciality.travel_date
        }
      })
        .catch(err => {
          console.log('err:' + err)
        })

    }
  }
}
</script>
<style scoped>
@import '../../../assets/css/pages/customer/customer.css';
</style>




// WEBPACK FOOTER //
// src/pages/agent/route/aRouteOrderResult.vue